import React, { useState } from "react";
import "../style/Home.css";
import LeaveMessage from "./LeaveMessage";
import { Link } from "react-router-dom";


const Home = () => {
  const [activeTab, setActiveTab] = useState("hot");

  return (
    <div className="home-page">
  
      <div id="searchResults"></div>
     <LeaveMessage />

     

  
      <section id="slider">
        <div
          id="carouselExampleCaptions"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="3000"
        >
        
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active"></button>
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1"></button>
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2"></button>
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="3"></button>
          </div>

          {/* Slides */}
          <div className="carousel-inner">
            <div className="carousel-item active">
              {/* <img src="/Banner/BN3.png" className="d-block w-100" alt="banner1" /> */}
              <img src={`${process.env.PUBLIC_URL}/Banner/BN3.png`} className="d-block w-100" alt="banner1" />
            </div>
            <div className="carousel-item">
              <img src="/Banner/BN2.webp" className="d-block w-100" alt="banner2" />
            </div>
            <div className="carousel-item">
              <img src="/Banner/BN4.jpg" className="d-block w-100" alt="banner3" />

            </div>
            <div className="carousel-item">
              <img src="/Banner/BN1.webp" className="d-block w-100" alt="banner4" />
            </div>
          </div>

          {/* Controls */}
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </div>
      </section>

      {/* Product Categories */}
      <section>
        <div className="product-details">
          <h2>PRODUCT'S CATEGORIES</h2>
          <p>
            A-OK is proud to offer a complete line of tubular motors, curtain motors, venetian motors,
            window openers and various smart scenes control systems.
          </p>
        </div>

        <div className="parent">
         
          <div className="child">
            <div className="div1">
              <div className="div1-child-1">
                <Link to="/product/tubular"><img id="img" src="/product-category/tubular.png" alt="Tubular Motor" /></Link>
              </div>
              <div className="div2-child-2">
                <Link to="/product/tubular/ac"><img id="img" src="/product-category/Ac.png" alt="AC Tubular Motor" /></Link>
              </div>
            </div>
            <div>
              <Link to="/product/tubular/dc"><img id="img" src="/product-category/DC.png" alt="DC Tubular Motor" /></Link>
            </div>
          </div>

          {/* Middle Column */}
          <div className="div2">
            <Link to="/product/curtain/"><img id="img" src="/product-category/curtain.png" alt="Curtain Motors" style={{height:"420px"}} /></Link>
          </div>

          {/* Right Column */}
          <div className="child">
            <div className="div3">
              <div className="div3-child-1">
                <Link to="/product/venetian/default"><img id="img" src="product-category/venetian.png" alt="Venetian Blinds Motor" /></Link>
              </div>
              <div className="div3-child-2">
                <Link to="/product/control"><img id="img" src="/product-category/control.png" alt="Control system" /></Link>
              </div>
            </div>
            <div>
              <Link to="/product/chain/Chainblind/AM43/AM43"><img id="img" src="/product-category/chain.jpeg" alt="Chain blinds Drive" /></Link>
            </div>
          </div>
        </div>
      </section>

      {/* Recommended Section */}
      <section className="recommended-section">
        <h2>Recommended Products</h2>
        <p>
          The company adopts the Japanese Toyota refined management model and strictly implements the ISO9001 quality
          management system to make our products have good operability and long-term stability.
        </p>

        <div className="product-tabs">
          <button className={`tab-btn ${activeTab === "hot" ? "active" : ""}`} onClick={() => setActiveTab("hot")} >
           <img src="/icons/pro_icon1.png" alt=""   className="product-tabs-img"/> HOT PRODUCTS
          </button>
          <button className={`tab-btn ${activeTab === "new" ? "active" : ""}`} onClick={() => setActiveTab("new")}>
            {/* <img src="/icons/pro_icon2.png" alt="" /> */}
            <img src="/icons/pro_icon2.png" alt=""   className="product-tabs-img"/> 
            NEW PRODUCTS
          </button>
        </div>

        {/* Hot Products */}
        {activeTab === "hot" && (
          <div id="hot" className="tab-pane active">
            <div className="card">
              <img src="/hot-products/3.jpg" alt="" />
              <h4>AM25 BUILT-IN LITHIUM Battery Tubular Motor</h4>
              <p>Lightweight motor with built-in lithium battery...</p>
              <Link to="/product/tubular/dc/am25/AM25-1-2-30-es-e" className="view-btn">VIEW MORE</Link>
            </div>

            <div className="card">
              <img src="/hot-products/2.jpg" alt="" />
              <h4>AM35 BUILT-IN RADIO Tubular Motor</h4>
              <p>Compact and quiet motor featuring built-in radio...</p>
              <Link to="/product/tubular/ac/AM35" className="view-btn">VIEW MORE</Link>
            </div>

            <div className="card">
              <img src="/hot-products/1.jpg" alt="" />
              <h4>AM45 BUILT-IN RADIO Tubular Motor</h4>
              <p>Medium-sized motor with built-in radio receiver, perfect for smooth</p>
              <Link to="/product/tubular/ac/am45" className="view-btn">VIEW MORE</Link>
            </div>

            <div className="card">
              <img src="/hot-products/AM75.jpg" alt="" />
              <h4>AM75 Strong AC Quiet Curtain  Motor</h4>
              <p>AM75 quiet curtain motor core technology is from Germarts</p>
              <Link to="/product/curtain/default/AM75/default" className="view-btn">VIEW MORE</Link>
            </div>

   

   
          </div>
        )}

        {/* New Products */}
        {activeTab === "new" && (
          <div id="new" className="tab-pane active">
             <div className="card">
              <img src="/new-product/LM100.jpg" alt="" />
              <h4>LM100 CURTAIN MOTOR</h4>
              <p>Reliable motor for large windows and curtain panels</p>
              <Link to="/product/curtain/default/LM100/default" className="view-btn">VIEW MORE</Link>
            </div>

            <div className="card">
              <img src="/new-product/AM93.png" alt="" />
              <h4>AM93 CURTAIN MOTOR</h4>
              <p>Smart curtain motor with app control</p>
              <Link to="/product/curtain/default/AM93/default" className="view-btn">VIEW MORE</Link>
            </div>

            <div className="card">
              <img src="/new-product/AM95.jpg" alt="" />
              <h4>AM95 CURTAIN MOTOR</h4>
              <p>High-end motor solution for curtains</p>
              <Link to="/product/curtain/default/AM95/default" className="view-btn">VIEW MORE</Link>
            </div>

            <div className="card">
              <img src="/new-product/AM98.jpg" alt="" />
              <h4>AM98 CURTAIN MOTOR</h4>
              <p>Powerful and silent motor for modern interiors</p>
              <Link to="/product/curtain/default/AM98/default" className="view-btn">VIEW MORE</Link>
            </div>

           

            
          </div>
        )}

        <div>
          <Link to="/product"><button className="recommended-btn">VIEW MORE PRODUCTS</button></Link>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-video">
              <video src="/video-file/10.mp4" autoPlay muted loop playsInline></video>
            </div>
            <div className="about-details">
              <h2><strong>ABOUT US</strong></h2>
              <p id="strong-p"><strong>A-OK MOTORS INDIA </strong></p>
              <p>
                {/* A-OK was established in 1998, dedicated to professional design and precision manufacturing of door and window motors and intelligent control systems. After 20 years of development and growth, the company has successively established Precision Motor Division, Precision Metal Stamping Division, and Precision Plastics Division. */}
                Promoted with the vision to bring global innovation in home automation to Indian households and commercial spaces, A-OK Motors India is a premium distributor of cutting-edge motorized solutions for blinds, curtains, and smart control systems.
                Backed by the international expertise of Guangdong A-OK Technology Grand Development Co. , Ltd. , a pioneer since 1998, our journey in India began in 2016. With a focus on efficiency, simplicity, and elegance, we are reimagining how Indian homes interact with technology.
              </p>
              <div className="features">
                <div className="feature-box">
                  <img src="/logo/manufacturer.png" alt="Manufacturer" />
                  <div className="feature-text">
                    <h6><strong>Professional Manufacturer</strong></h6>
                    {/* <p>23 years specialized manufacturer of intelligent motors and control</p> */}
                    <p>27years specialized manufacturer of intelligent motors and control</p>
                  </div>
                </div>

                <div className="feature-box">
                  <img src="/logo/fast delivery.png" alt="Fast Delivery" />
                  <div className="feature-text">
                    <h6><strong>Fast Delivery</strong></h6>
                    <p>They are determined to search for the right market solutions for their</p>
                  </div>
                </div>
              </div>
              <Link to="/about"><button className="home-about-btn">VIEW MORE ABOUT</button></Link>
            </div>
          </div>
        </div>
      </section>

      {/* Video Centre */}
      <section>
        <div className="video-centre">
          <h2>VIDEO CENTRE</h2>
          <p>
            The company adopts the Japanese Toyota refined management model and strictly implements the ISO9001 quality management system to make our products have good operability and long-term stability.

          </p>
        </div>
        <div className="video-carousel-container">
          <div className="video-carousel">
            <div className="video-slide"><video src="/video-file/1.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/2.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/3.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/4.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/5.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/6.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/7.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/8.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/9.mp4" autoPlay muted loop playsInline></video></div>
            <div className="video-slide"><video src="/video-file/10.mp4" autoPlay muted loop playsInline></video></div>

          </div>
        </div>
        <div className="video-btn">
          <Link to="/videocentre"><button className="videocentre-btn">VIEW MORE VIDEOS</button></Link>
        </div>
      </section>

      
    </div>
  );
};

export default Home;
